import http from "../../utils/http";

export const subscribeExcel = () => {
  return new Promise((resolve, reject) => {
    http
      .post("/newsletter/subscribe/list/files", {}, {
        responseType: "arraybuffer",
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const subscribeUploadExcel = (formData) => {
  return new Promise((resolve, reject) => {
    http
      .post("/newsletter/subscribe/excelupload", formData)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const subscribeList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/newsletter/subscribe/list", body)
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const editSubscribe = (body, idx) => {
  return new Promise((resolve, reject) => {
    http.put(`/newsletter/subscribe?idx=${idx}`, body)
      .then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const deleteSubscribe = (data) => {
  return new Promise((resolve, reject) => {
    http.delete("/newsletter/subscribe", { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      })
      ;
  });
};

export const boardList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/newsletter/board/list", body)
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const addBoard = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/newsletter/board", body)
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const editBoard = (body, idx) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/newsletter/board/${idx}`, body)
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};
export const deleteBoard = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/newsletter/board`, { data })
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const sendNewsLetter = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/newsletter/mailForm/send`, params)
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};


export const mailFormList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/newsletter/mailForm/list", body)
      .then((res) => {
        resolve(res.data?.mailForms);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const addMailForm = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/newsletter/mailForm", body)
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};
export const editMailForm = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/newsletter/mailForm/${idx}`, body)
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const deleteMailForm = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/newsletter/mailForm`, { data })
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const subscriberList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/mailTarget/list`, params)
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const addSubscriber = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/mailTarget`, params)
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const editSubscriber = (idx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/mailTarget/${idx}`, params)
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};
export const deleteSubscribers = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/mailTarget`, { data })
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const subscriberUploadExcel = (formData) => {
  return new Promise((resolve, reject) => {
    http
      .post("/mailTarget/excel/upload", formData)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const subscriberDownloadExcel = (formData) => {
  return new Promise((resolve, reject) => {
    http
      .post("/mailTarget/excel/download", {}, {
        responseType: "arraybuffer",
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
  });
};